/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// Automatically Add In Stock to Active Collection Filters - Erman -
(function () {
  if (!window.location.pathname.includes('/collections/')) return;

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.matches('input[type="checkbox"][name^="filter."], input[type="radio"][name^="filter."]')) return;
    if (!target.checked || target.name === 'filter.v.availability') return;

    var currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.get('filter.v.availability') === '1') return;

    var url = new URL(window.location.origin + window.location.pathname);
    var sortParam = currentUrl.searchParams.get('sort_by');
    if (sortParam) url.searchParams.set('sort_by', sortParam);
    url.searchParams.set('filter.v.availability', '1');

    document.querySelectorAll('input[type="checkbox"][name^="filter."], input[type="radio"][name^="filter."]').forEach(function (input) {
      if (input.checked && input.name !== 'filter.v.availability') {
        if (!url.searchParams.getAll(input.name).includes(input.value)) {
          url.searchParams.append(input.name, input.value);
        }
      }
    });

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(url.toString());
  }, true);
})();